import { render } from "./HeroiconsSolidMenuAlt3.vue?vue&type=template&id=d909da82"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMenuAlt3.vue"]])

export default __exports__